module.exports = __webpack_public_path__ + "2b967010d0745b50dc4f4cf3c0993d40.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/806.png
// module id = 1710
// module chunks = 2